import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Flicking from "@egjs/vue-flicking";
import "@egjs/vue-flicking/dist/flicking.css";
// Or, if you have to support IE9
import "@egjs/vue-flicking/dist/flicking-inline.css";
import "@egjs/flicking-plugins/dist/flicking-plugins.css";
import VueSocketIO from "vue-socket.io";
import SocketIO from "socket.io-client";

Vue.use(Flicking);

Vue.config.productionTip = false;
const socketConnection = SocketIO("https://wildtechdemo.eram.cat", {
  cors: { origins: "*" },
});

Vue.use(
  new VueSocketIO({
    debug: true,
    connection: socketConnection,
  }),
);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
